import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Sticky 50/33/33-style A/B/C bucket assignment for an experiment, persisted
 * in localStorage so a single user stays in the same variant across visits.
 *
 *   const { variant, recordEvent } = useABVariant({
 *     experiment: 'hero_headline',
 *     variants: ['A', 'B', 'C'],
 *   });
 *
 *   recordEvent('impression', { audience: 'buyer' });
 *   recordEvent('click_primary', { audience: 'buyer' });
 */
export const useABVariant = ({ experiment, variants = ['A', 'B'] }) => {
  const [variant, setVariant] = useState(null);
  const [visitorId, setVisitorId] = useState(null);

  useEffect(() => {
    try {
      const storeKey = `ab_${experiment}`;
      let v = localStorage.getItem(storeKey);
      if (!v || !variants.includes(v)) {
        v = variants[Math.floor(Math.random() * variants.length)];
        localStorage.setItem(storeKey, v);
      }
      let vid = localStorage.getItem('ab_visitor_id');
      if (!vid) {
        // 12-char base36 anonymous ID — purely for bucket de-duplication
        vid = Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 6);
        localStorage.setItem('ab_visitor_id', vid);
      }
      setVariant(v);
      setVisitorId(vid);
    } catch {
      // localStorage may be blocked (private mode) — fall back to a session-only A
      setVariant(variants[0]);
    }
  }, [experiment, variants]);

  const recordEvent = (event, extras = {}) => {
    if (!variant) return;
    axios
      .post(`${BACKEND_URL}/api/ab/event`, {
        experiment,
        variant,
        event,
        visitor_id: visitorId,
        audience: extras.audience || 'buyer',
        page: extras.page || (typeof window !== 'undefined' ? window.location.pathname : '/'),
      })
      .catch(() => {});
  };

  return { variant, visitorId, recordEvent };
};

export default useABVariant;
